export enum EResourceViewType {
  FUNNEL,
  TACTIC,
}
